const ROW_TYPE_FORM = 'Form';
const ROW_TYPE_CATEGORY = 'Category';
const ROW_TYPE_MODULE = 'Module';

export { ROW_TYPE_FORM, ROW_TYPE_CATEGORY, ROW_TYPE_MODULE };
